import { render } from "./SystemSetupMasterSlaveModal.vue?vue&type=template&id=199ac424&scoped=true&ts=true"
import script from "./SystemSetupMasterSlaveModal.vue?vue&type=script&lang=ts"
export * from "./SystemSetupMasterSlaveModal.vue?vue&type=script&lang=ts"

import "./SystemSetupMasterSlaveModal.vue?vue&type=style&index=0&id=199ac424&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-199ac424"]])

export default __exports__